module.exports = __webpack_public_path__ + "img/tu06.6de1de01.png";